export default {
  namespaced: true,
  state: {
    token: window.localStorage.token ? window.localStorage.token : '',
    user: window.localStorage.user ? JSON.parse(window.localStorage.user) : {},
    permissions: window.localStorage.permissions ? JSON.stringify(window.localStorage.permissions) : [],
    showNotification: false,
  },
  mutations: {
    storeToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    storeUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    storePermissions(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },

    logout(state) {
      state.token = ''
      state.user = {}
      state.permissions = []
      localStorage.clear()
      window.location.href = '/login'
    },
  },
  getters: {
    getToken(state) {
      return state.token
    },
    getPermissions(state) {
      return state.permissions
    },
    getUser(state) {
      return state.user
    },
  },
}
